import { TenantPlusFeature, TenantPlusModalOpenTrigger } from './TenantPlusModalOpenTriggers';

export const tenantPlusServicePaths = {
  en: 'en/tenantplus',
  de: 'de/mieterplus',
  fr: 'fr/locataireplus',
  it: 'it/tenantplus',
};

export const generateTenantPlusSigninUrl = (currentLocale: string): string => {
  const signinUrl = new URL(
    `${import.meta.env.VUE_APP_BASE_URL}/${tenantPlusServicePaths[currentLocale as keyof typeof tenantPlusServicePaths]}/sign-in`,
  );

  if (typeof window === 'undefined') {
    return signinUrl.toString();
  }

  const callbackUrl = new URL(window.location.href);
  callbackUrl.searchParams.append('t_nonce', (Date.now() % 1000).toString());
  signinUrl.searchParams.append('callbackUrl', callbackUrl.toString());

  return signinUrl.toString();
};

export const generateTenantPlusLandingPageUrl = (
  currentLocale: string,
  entryPoint: string,
): string => {
  const landingPageUrl = new URL(
    `${import.meta.env.VUE_APP_BASE_URL}/${tenantPlusServicePaths[currentLocale as keyof typeof tenantPlusServicePaths]}`,
  );

  landingPageUrl.searchParams.append('entryPoint', entryPoint);

  return landingPageUrl.toString();
};

export const generateTenantPlusManualPaymentUrl = (
  currentLocale: string,
  entryPoint: string,
  tenantPlusFeature: TenantPlusFeature,
): string => {
  const paymentUrl = new URL(
    `${import.meta.env.VUE_APP_BASE_URL}/${tenantPlusServicePaths[currentLocale as keyof typeof tenantPlusServicePaths]}/payment`,
  );
  paymentUrl.searchParams.append('entryPoint', entryPoint);

  if (typeof window === 'undefined') {
    return paymentUrl.toString();
  }

  const callbackUrl = new URL(window.location.href);
  callbackUrl.searchParams.append('plusSignup', 'true');
  callbackUrl.searchParams.append('plusFeature', tenantPlusFeature);
  paymentUrl.searchParams.append('callbackUrl', callbackUrl.toString());

  return paymentUrl.toString();
};

export const generateTenantPlusTrackingEntryPoint = (
  offerType: string | undefined,
  trigger: TenantPlusModalOpenTrigger,
): string => {
  if (!offerType) {
    return '';
  }
  switch (trigger) {
    case TenantPlusModalOpenTrigger.REQUEST_ADDRESS:
    case TenantPlusModalOpenTrigger.CONTACT_FORM:
    case TenantPlusModalOpenTrigger.PHONE_NUMBER:
    case TenantPlusModalOpenTrigger.LISTER_PHONE_NUMBER:
    case TenantPlusModalOpenTrigger.APPOINTMENT_VIEWING:
      return `pdp_${offerType.toLowerCase()}_contact`;
    case TenantPlusModalOpenTrigger.MORE_IMAGES:
      return 'pdp_blur_image';
    case TenantPlusModalOpenTrigger.CRIF_MODAL:
    default:
      return `pdp_${offerType.toLowerCase()}_bottomsheet`;
  }
};
